import { render, staticRenderFns } from "./xian-A-1.vue?vue&type=template&id=238c0aed&"
import script from "./xian-A-1.vue?vue&type=script&lang=js&"
export * from "./xian-A-1.vue?vue&type=script&lang=js&"
import style0 from "./xian-A-1.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "xian-A-1.vue"
export default component.exports